import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "./assets/css/index.less";
import { Button, Tabs, TabPane, Input,Drawer } from 'element-ui';

Vue.use(Button)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Input)
Vue.use(Drawer)
Vue.config.productionTip = false

router.beforeEach((to,from,next) =>{
  if(to.meta.title){
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


